import React from 'react';
import { Container, List, Paper, Text, Title } from '@mantine/core';
import useStyles from './Static.styles';

// TODO: REFACTOR THE LIST ITEM LOGIC - CHECK POLICY PAGE

interface Item {
    label: string;
}

export const TermsLanding: React.FC = () => {

    const { classes } = useStyles();

    const listTermsData: Item[] = [
        { label: 'Reservation is confirmed only after complete settlement of rental amount, security deposit, taxes and confirmation email sent by DXB Stay (Vacation Rentals Portal) to the guest.' },
        { label: 'The guest has read, agrees to, and understands that the house policies are an integral part of this agreement.' },
        { label: 'The guest agrees to rent the property for the period mentioned on the reservation form and is granted limited permission to occupy the property for temporary accommodation purposes and usage only. The reservation terms and house policies are in no way a residential tenancy agreement and does not fall under the Dubai residential tenancy legislation(s).' },
    ];

    const listTermsItems = listTermsData.map((item) => {

        return (
            <List.Item pt={10} pb={10} pr={16}
                       key={item.label}>{item.label}
            </List.Item>
        )
    });

    const listTermsNestedOneData: Item[] = [
        { label: 'Sublease of the property or transfer of the reservation to any other party is strictly prohibited.' },
        { label: 'Guest must carry and be able to present upon request a valid original passport and the original debit/credit card used for the reservation.' },
        { label: 'Any minors should be accompanied by an adult at the time of check-in.' },
        { label: 'The rental amount is inclusive of all utility bills and housekeeping services twice a week. This does not include use of on demand video services, any upgrades to the existing internet or cable TV package, paid local or international calls from the landline of the property and additional services or items requested by the guest, any such charges will be paid separately by the guest.' },
        { label: 'The maximum capacity of guests allowed in the property should be strictly observed and followed.' },
        { label: 'Additional visitors and guests are not allowed for overnight stays.' },
        { label: 'Guest agrees to provide housekeeping and service staff access to the property.' },
        { label: 'Guest must inform DXB Stay (Vacation Rentals Portal) of any damage to the property or its contents.' },
        { label: 'Guest agrees that DXB Stay (Vacation Rentals Portal) and the operator are not liable under any circumstances for loss, theft, damage to personal belongings, injury, illness, sickness or death to the guests or visitors.' },
        { label: 'Guest agrees that in case of non-compliance of the reservation terms and house policies the operator has the right to evict the guest from the property and in any such case the guest will forfeit the total rental amount and security deposit.' },
        { label: 'All rates and charges are calculated and paid in AED or its equivalent.' },
        { label: 'All rental payments made towards the reservation of the property are non-refundable in case of cancellation, no show, or early departure.' },
        { label: 'If the reservation is cancelled by the operator for any reason, then the entire amount will be refunded to the guest with no other liabilities.' },
        { label: 'In case of overstaying guest/s a penalty of AED 1,000/- per day in addition to the daily rental rate will be applied and all possible measures will be taken to evict the guest, including blocking access to the property, disconnection of utilities and involvement of the authorities.' },
        { label: 'In case the guest wants to extend the stay this should be agreed upon and paid for in advance before the check-out date and is subject to availability.' },
        { label: 'Security deposits are refundable subject to the below terms and conditions.' },
    ];

    const listTermsNestedOneItems = listTermsNestedOneData.map((item) => {

        return (
            <List.Item pt={10} pb={10} pr={16}
                       key={item.label}>{item.label}
            </List.Item>
        )
    });

    const listTermsTwoData: Item[] = [
        { label: 'Guest agrees to pay the required security deposit at the time of reservation, refunds will be processed within 7 to 14 nights after check-out. The security deposit is subject to deductions in the event of:' },
    ];

    const listTermsTwoItems = listTermsTwoData.map((item) => {

        return (
            <List.Item pt={10} pb={10} pr={16}
                       key={item.label}>{item.label}
            </List.Item>
        )
    });

    const listTermsNestedTwoData: Item[] = [
        { label: 'Any damages to the property or common areas.' },
        { label: 'Missing or damaged items in the property.' },
        { label: 'Loss or damage of access cards provided to the guest.' },
        { label: 'Non-compliance of house policies.' },
        { label: 'Penalties imposed by community management and/or government authorities for non-compliance of any rules or regulations by the guests or their visitors.' },
        { label: 'For use of on demand video services, upgrades to the existing internet or cable TV package, paid local or international calls from the landline of the property and any unsettled bills for extra services or items requested by the guests or visitors.' },
    ];

    const listTermsNestedTwoItems = listTermsNestedTwoData.map((item) => {

        return (
            <List.Item pt={10} pb={10} pr={16}
                       key={item.label}>{item.label}
            </List.Item>
        )
    });

    const listInvolvedData: Item[] = [
        { label: 'DXB Stay (Vacation Rentals Portal): DXB Stay (Vacation Rentals Portal) only provides a platform through which operators can advertise, market, sell promote and/or offer their products and services for order, purchase, reservation, rent or hire, and through which relevant visitors of the platform can discover, search, compare, and make an order, reservation, purchase, or payment.' },
        { label: 'By using or utilizing the platform, you enter a direct (legally binding) contractual relationship with the operator in which you make a reservation or purchase a product or service.' },
        { label: 'From the point at which you make your reservation, we act solely as an intermediary between you and the operator. We transmit the relevant details of your reservation to the relevant operator and send you a confirmation email for and on behalf of the operator. DXB Stay (Vacation Rentals Portal) does not (re)sell, rent out, offer any (travel) product or service.' },
        { label: 'Operator: The operator is the provider of the product and/or services and has the relevant permits in place to conduct the activities.' },
        { label: 'Guests: Any individual(s) or organization using the platform for making purchases and/or reservations.' },
    ];

    const listInvolvedItems = listInvolvedData.map((item) => {

        return (
            <List.Item pt={10} pb={10} pr={16}
                       key={item.label}>{item.label}
            </List.Item>
        )
    });

    return (
        <Container>
            <Paper className={classes.paper}>

                <Title className={classes.h1} order={1}>
                    Terms & Conditions
                </Title>
                {/*<Title className={classes.h2} order={2}>
                    Vacation Rentals Portal
                </Title>*/}

                <List pt={10} className={classes.staticListMain}>
                    {listTermsItems}
                </List>

                <List className={classes.staticListNested} listStyleType="circle">
                    {listTermsNestedOneItems}
                </List>

                <List pt={10} className={classes.staticListMain}>
                    {listTermsTwoItems}
                </List>

                <List className={classes.staticListNested} listStyleType="circle">
                    {listTermsNestedTwoItems}
                </List>

                <Text color="red" pt={30} pb={30} size="sm">
                    *** In case the security deposit is not sufficient to cover any of the above the guest agrees to be fully liable and pay any difference amount immediately to
                    complete the shortfall.
                </Text>
                <Title className={classes.h1} order={1}>
                    Involved Parties
                </Title>
                {/*<Title className={classes.h2} order={2}>
                    Vacation Rentals Portal
                </Title>*/}

                <List pt={10} pb={20} className={classes.staticListMain}>
                    {listInvolvedItems}
                </List>

            </Paper>
        </Container>
    );
};
